import { render, staticRenderFns } from "./DocumentationPage.vue?vue&type=template&id=70644a98&scoped=true&"
import script from "./DocumentationPage.vue?vue&type=script&lang=js&"
export * from "./DocumentationPage.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationPage.vue?vue&type=style&index=0&id=70644a98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70644a98",
  null
  
)

export default component.exports